import React from "react";
import { Switch, Route } from "react-router-dom";

import { Row } from "antd";

import CustomerDetail from "./CustomerDetail";
import SearchUser from "./SearchUser";

const Synchronize = ({ ...props }) => {
	const path = "/helpdesk";
	return (
		<Row
			style={{
				width: "100%",
				padding: "40px 25px 70px",
				margin: "60px auto 20px",
				backgroundColor: "#FAFAFA",
			}}
			gutter={[12, 48]}>
			<Switch>
				<Route path={`${path}/:userType/:country_code/:customerID`} component={CustomerDetail} />
				<Route exact path={`${path}`} component={SearchUser} />
				
				<Route path="*" component={() => <>404 NOT FOUND</>}></Route>
			</Switch>
		</Row>
	);
};

export default Synchronize;
